import React, { useState } from 'react';
import { toast } from 'react-toastify';
import ProtocolService from '../../../../../service';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import { IconWrapper, StyledButton, TextLabel } from './styled';

export function MarkAsReadUnreadButton({
  isRead,
  protocolId,
  commentId,
  onRefresh
}) {
  const [isLoading, setIsLoading] = useState(false);

  const handleToggleRead = async () => {
    if (!protocolId || !commentId || isLoading) return;

    setIsLoading(true);

    try {
      if (isRead) {
        await ProtocolService.markCommentAsUnread({ protocolId, commentId });
        toast.success('Comentário marcado como não lido');
      } else {
        const userId = localStorage.getItem('login');
        await ProtocolService.markCommentAsRead({
          protocolId,
          commentId,
          userId
        });
        toast.success('Comentário marcado como lido');
      }

      if (onRefresh && typeof onRefresh === 'function') {
        await onRefresh();
      }
    } catch (error) {
      toast.error('Falha ao atualizar status de leitura do comentário');
      // eslint-disable-next-line no-console
      console.error('Error toggling comment read state', error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <StyledButton
      $isRead={isRead}
      onClick={handleToggleRead}
      title={isRead ? 'Marcar como não lido' : 'Marcar como lido'}
      disabled={isLoading}
    >
      <IconWrapper>
        {isRead ? <FaEyeSlash size={14} /> : <FaEye size={14} />}
      </IconWrapper>
      <TextLabel>
        {isRead ? 'Marcar como não lido' : 'Marcar como lido'}
      </TextLabel>
    </StyledButton>
  );
}
